export default __webpack_public_path__ + "static/media/AgileDevelopment.15bd8387.jpg";